import { TearsheetProps } from '@procore/core-react/dist/_typedoc/Tearsheet/Tearsheet.types.json';
import * as React from 'react';
export default {
  TearsheetProps,
  React
};